import type { QueryClient } from '@tanstack/react-query';
import { persistQueryClient } from '@tanstack/react-query-persist-client';
import { queryPersister } from './persistor';

export function setupQueryClientPersistence(queryClient: QueryClient) {
  persistQueryClient({
    queryClient,
    persister: queryPersister,
    maxAge: 1000 * 60 * 60 * 24,
  });
}
